<template>
    <div class="order-box">
      <nav-index :title="'我的订单'"/>
      <tabs @changeTaaab="changeTaaab" ref="tabs"/>
      <div class="order-card-block">
        <div v-if="showEmyptyImg && !orderLoading">
            <div class="header" v-show="showSalesInSearch">
                <input type="text" :placeholder="'订单号/名称'" @keyup.enter="handleSearch" v-model="inputText" ref="input">
                <img src="../../assets/images/search.png" alt="" width="20" height="20" class="searchImg" @click="handleSearch">
            </div>
            <div class="none-list">
                <img src="../../assets/images/none.svg" alt="">
                <div class="none">您还没有订单喔~</div>
            </div>
        </div>
        <div v-else>
          <div class="header" v-show="showSalesInSearch">
              <input type="text" :placeholder="'订单号/名称'" @keyup.enter="handleSearch" v-model="inputText" ref="input">
              <img src="../../assets/images/search.png" alt="" width="20" height="20" class="searchImg" @click="handleSearch">
          </div>
          <order-card v-for="(order,i) in orderInfo" :key="i" :orderInfo="order" :tabId="tabId" @deleteOrder="deleteOrderConfirm" :logoUrl="logoUrl"
            @pay="openPayment" @received="receivedGoodsConfirm(order.oid)" @expedited="expedited" @goExpressPage="goExpressPage(order)"/>
            <div v-show="orderInfo.length > 0">
                <div class="load-more"  v-if="orderInfo.length !== total || !orderInfo.length">正在加载中...</div>
                <div class="load-more" v-else>已经到底部啦！</div>
            </div>
        </div>
      </div>
      <confirm ref="confirm" @handleDelete="deleteOrder"/>
      <confirm-received ref="confirmReceived" @handleReceived="receivedGoods"/>
    </div>
</template>

<script>
import OrderCard from '../../components/card/OrderCard.vue'
import NavIndex from '../../components/nav/index.vue'
import Tabs from '../../components/tabs/index.vue'
import ConfirmReceived from '../../components/dialog/ConfirmReceived.vue'
import { queryAllOrderByUid, queryKindStatusOrder, deleteOrderByOid, updateOrderByOid, queryOrderOriginByInputVal } from '@/api/api'
import Confirm from '../../components/dialog/Confirm.vue'
import {Toast} from 'vant'
import { getopenIdByCode } from '@/utils/index';
const seo = require('../../../config/index')

export default {
  name: 'Order',
  components: {
    NavIndex,
    Tabs,
    OrderCard,
    Confirm,
    ConfirmReceived,
  },
  created(){
    this.$bus.$on('changeTaaab', this.changeTaaab)
    getopenIdByCode()
  },
  activated(){
    if(this.$route.query.tabId){
      if(this.$refs.tabs){
        this.$refs.tabs.changeTab(Number(this.$route.query.tabId), true)
      }
      this.changeTaaab(this.$route.query.tabId)
    } else {
      this.getData('all')
    }
  },
  mounted(){
    this.scrollTime = setTimeout(() => {
        document.addEventListener('scroll', this.handleScroll);
        document.documentElement.scrollTop = this.scroll
        document.body.scrollTop = this.scroll
    }, 0)
  },
  destroyed(){
    document.removeEventListener('scroll', this.handleScroll);
    clearTimeout(this.scrollTime)
  },
  data:()=>{
    return {
      tabId: '0',
      showEmyptyImg: false,
      orderInfo:[],
      orderLoading: false,
      showSalesInSearch: false,
      showScrollTopBtn: false,
      statusTemp: '',
      isEnd: false,
      total: 0,
      limit: 30,
      scroll: 0,
      inputText: '',
      logoUrl: seo.config.logo,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : {}
    }
  },
  methods:{
    getData(id){
      this.showEmyptyImg = false
      this.orderLoading = true
      // 查询全部订单
      if(id === 'all'){
        queryAllOrderByUid({ uid: this.userInfo.uid, limit: this.limit }).then(res=>{
            this.orderInfo = []
            let resData = res.data.data.data
            this.total = res.data.data.count
            if(resData.length > 0){
              resData.forEach((item)=>{
                let temp = {}
                temp.oid = item.oid
                temp.lists = item.lists
                temp.totalPrice = item.total_price
                temp.discountPrice = item.discount
                temp.finalPayPrice = item.finally_price
                temp.payment = item.payment
                temp.createAt = item.createdAt
                temp.status = item.order_status
                temp.waybill = item.waybill
                temp.phoneNum = item.phone_num
                temp.shop = item.shop
                this.orderInfo.push(temp)
              })
            } else {
              this.showEmyptyImg = true
            }
            this.showSalesInSearch = this.orderInfo.length > 15 ? true : false
            this.orderLoading = false
            this.isEnd = false // 必须
        })
      } else {
        queryKindStatusOrder({ uid: this.userInfo.uid, order_status: id, limit: this.limit }).then((res)=>{
            this.orderInfo = []
            let resData = res.data.data.data
            this.total = res.data.data.count
            if(resData.length > 0){
              resData.forEach((item)=>{
                let temp = {}
                temp.oid = item.oid
                temp.imgUrl = item.imgUrl
                temp.title = item.title
                temp.type = item.type
                temp.shop = item.shop
                temp.lists = item.lists
                temp.totalPrice = item.total_price
                temp.discountPrice = item.discount
                temp.finalPayPrice = item.finally_price
                temp.payment = item.payment
                temp.createAt = item.createdAt
                temp.status = item.order_status
                temp.waybill = item.waybill
                temp.phoneNum = item.phone_num
                this.orderInfo.push(temp)
              })
            } else {
              this.showEmyptyImg = true
            }
            this.showSalesInSearch = this.orderInfo.length > 15 ? true : false
            this.orderLoading = false
            this.isEnd = false // 必须
        })
      }
    },
    changeTaaab(id){
      this.tabId = String(id)
      this.scroll = 0
      this.limit = 30
      this.inputText = ''
      document.documentElement.scrollTop = this.scroll
      document.body.scrollTop = this.scroll
      if(String(id) === '0'){
        this.getData('all')
      } else if(String(id) === '1'){
        this.getData('orderPaying')
      } else if(String(id) === '2'){
        this.getData('orderPicking')
      } else if(String(id) === '3'){
        this.getData('orderReceived')
      } else if(String(id) === '4'){
        this.getData('orderApplyRefund')
      }
    },
    getDataByTabsId(){
      this.inputText = ''
      if(this.tabId === '0'){
        this.getData('all')
      } else if(this.tabId === '1'){
        this.getData('orderPaying')
      } else if(this.tabId === '2'){
        this.getData('orderPicking')
      } else if(this.tabId === '3'){
        this.getData('orderReceived')
      } else if(this.tabId === '4'){
        this.getData('orderApplyRefund')
      }
    },
    deleteOrderConfirm(oid){
      this.oidTemp = oid
      this.$refs.confirm.show('deleteOrder')
    },
    deleteOrder(){
      this.$refs.confirm.show('deleteOrder')
      deleteOrderByOid({ oid: this.oidTemp }).then(()=>{
        this.getDataByTabsId()
      })
    },
    openPayment(oid){
      this.$router.push({ path:'/order-desc', query:{ oid: oid, tabId: this.tabId } })
    },
    receivedGoodsConfirm(oid){
      this.oidTemp = oid
      this.$refs.confirmReceived.show()
    },
    receivedGoods(){
      let orderInfoTemp = this.orderInfo.find(item => item.oid === this.oidTemp)
      let order_status = orderInfoTemp.payment === '3' ? 'orderCommentMonthlyPay' : 'orderComment' // 已收货但要月结收款 已完成
      updateOrderByOid({ oid: this.oidTemp, order_status: order_status }).then(()=>{
        this.getDataByTabsId()
      })
    },
    goExpressPage(order){
      let oid = order.oid
      let waybill = order.waybill
      let phoneNum = order.phoneNum
      this.$router.push({ path:'/express', query:{ oid:oid, waybill: waybill, phoneNum: phoneNum } })
    },
    expedited(){
      Toast('已提醒商家发货');
    },
    handleSearch(){
      this.orderLoading = true
      if(this.tabId === '0'){
        this.statusTemp = 'all' // 全部
      } else if(this.tabId === '1'){
        this.statusTemp = 'orderPaying' //
      } else if(this.tabId === '2'){
        this.statusTemp = 'orderPicking' // 待发货
      } else if(this.tabId === '3'){
        this.statusTemp = 'orderReceived' //
      } else if(this.tabId === '4'){
        this.statusTemp = 'orderApplyRefund' // 售后
      }
      if(this.inputText.length > 0){
        this.search()
      } else {
        this.getData(this.statusTemp)
      }
    },
    search(){
      queryOrderOriginByInputVal({ limit: this.limit, inputVal: this.inputText, status: this.statusTemp, uid: this.userInfo.uid }).then((res)=>{
        this.orderInfo.length = 0
        let resData = res.data.data.data
        this.total = res.data.total
        if(resData.length > 0){
          resData.forEach((item)=>{
            let temp = {}
            temp.oid = item.oid
            temp.imgUrl = item.imgUrl
            temp.title = item.title
            temp.type = item.type
            temp.totalPrice = item.total_price
            temp.discountPrice = item.discount
            temp.finalPayPrice = item.finally_price
            temp.payment = item.payment
            temp.createAt = item.createdAt
            temp.updatedAt = item.updatedAt
            temp.amount = item.amount
            temp.status = item.order_status
            temp.waybill = item.waybill
            temp.lists = item.lists
            temp.shop = item.shop
            this.orderInfo.push(temp)
          })
          this.showEmyptyImg = false
        } else {
          this.showEmyptyImg = true
        }
        this.orderLoading = false
      })
    },
    handleScroll(){
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight // 可视区的高度
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条距离顶部的距离
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight //dom元素的高度，包含溢出不可见的内容
        //vue中获取滚动条到底部的距离
        let scrollBottom = scrollHeight - scrollTop - windowHeight
        if(scrollTop - windowHeight > 0){
            this.showScrollTopBtn = true
        } else {
            this.showScrollTopBtn = false
        }
        if(this.tabId === '0'){
          this.statusTemp = 'all' // 全部
        } else if(this.tabId === '1'){
          this.statusTemp = 'orderPaying' //
        } else if(this.tabId === '2'){
          this.statusTemp = 'orderPicking' // 待发货
        } else if(this.tabId === '3'){
          this.statusTemp = 'orderReceived' //
        } else if(this.tabId === '4'){
          this.statusTemp = 'orderApplyRefund' // 售后
        }
        //以下三个条件不执行数据加载：1.数据正在加载的状态，2.已经到底了，3.滚动条距离底部的距离小于100px
        if (!this.orderLoading && !this.isEnd && scrollBottom < 100 && this.orderInfo.length < this.total) {
            this.limit += 30
            this.isEnd = true
            this.scroll = scrollTop
            if(this.inputText.length > 0){
                this.handleSearch()
            } else {
              this.getData(this.statusTemp)
            }
        } else {
            this.isEnd = false
        }
    }
  },
}
</script>

<style scoped lang="scss">
.order-box {
  min-height: 100vh;
  .order-card-block {
    padding: 95px 0 10px;
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
}
.header {
    display: flex;
    align-items: center;
    margin: 10px 10px 0 10px;
    input {
        width: 100%;
        border-radius: 5px;
        height: 40px;
        border: 1px solid #eee;
        padding-left: 15px;
        box-sizing: border-box;
        -webkit-appearance: none;
    }
    div {
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        margin-top: 10px;
        width: 40px;
        min-width: 48px;
        padding-right: 10px;
    }
    .searchImg {
        width: 20px;
        position: absolute;
        right: 20px;
    }
}
.none-list {
    margin: 60px auto 20px;
    width: 100%;
    max-width: 625px;
    .none {
        margin: 10px 0 0;
        color: #969699;
    }
    img {
        min-height: 142px;
    }
}
.load-more {
  text-align: center;
  color: #969699;
  padding: 0px 0 5px 0;
  font-size: 14px;
}
</style>